import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Redirect as RouterRedirect } from "react-router-dom"

// ----------------------------------------------------------------------------

function _Redirect(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return <RouterRedirect to="/" from="/events" />
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Redirect.propTypes = {
    className: PropTypes.string.isRequired,
}

_Redirect.defaultProps = {}

// ----------------------------------------------------------------------------

const Redirect = styled(_Redirect)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default Redirect
